import View from '@play-co/timestep-core/lib/ui/View';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import uiConfig from 'src/lib/ui/config';
import bitmapFonts from 'src/lib/bitmapFonts';
import { openPopupPromise, closePopup } from 'src/lib/popups/popupOpenClose';
import PopupMonitor from '../../logic/PopupMonitor';
import { createEmitter } from 'src/lib/Emitter';
import GCInstant from '@play-co/gcinstant';

const cheatPopups = [
  'popupCheats',
  'popupTestPopups',
  'popupCheatsAB',
] as const;
type CheatPopup = typeof cheatPopups[number];

const togglePopup = async (id: CheatPopup) => {
  const openCheatPopups = cheatPopups.filter((id) => PopupMonitor.isOpen(id));
  openCheatPopups.forEach(closePopup);

  if (!openCheatPopups.includes(id)) {
    void openPopupPromise(id, {});
  }
};

export default function createCheatsButton(opts: { superview: View }) {
  const container = new View({
    superview: opts.superview,
    zIndex: 20000, // on top of the world
    x: 15,
    width: 300,
    height: 60,
    centerOnOrigin: true,
    infinite: true,
    canHandleEvents: false,
    r: Math.PI / 2,
  });

  // anchor elements
  createEmitter(container, ({ ui }) => ui.screenSize).addListener((screen) => {
    container.updateOpts({ y: (screen.height - 100) / 2 });
  });

  const line = new View({
    superview: container,
    x: 0,
    y: 0,
    width: container.style.width / 3 - 1,
    height: container.style.height,
    clip: true,
  });

  const cheatsContainer = new View({
    superview: container,
    x: 0,
    y: 0,
    width: container.style.width / 3 - 1,
    height: container.style.height,
    clip: true,
  });

  const labelOffsetY = GCInstant.osType === 'IOS' ? -2 : -8;

  new ButtonScaleViewWithText({
    superview: cheatsContainer,

    x: 0,
    y: 0,
    width: 120,
    height: 60,

    labelOffsetX: -10,
    labelOffsetY,
    localeText: () => 'Cheats',
    fontSize: 20,
    font: bitmapFonts('Body'),

    onClick: () => togglePopup('popupCheats'),

    ...uiConfig.buttons.primary,
    tracking: { feature: 'cheats', $subFeature: 'toggle-popup-cheats' },
  });

  const testsContainer = new View({
    superview: container,

    x: container.style.width / 3 + 1,
    y: 0,
    width: container.style.width / 3 - 21,
    height: container.style.height,

    clip: true,
  });

  new ButtonScaleViewWithText({
    superview: testsContainer,

    x: -21,
    y: 0,
    width: 120,
    height: 60,

    labelOffsetY,
    localeText: () => 'Tests',
    fontSize: 20,
    font: bitmapFonts('Body'),
    onClick: () => togglePopup('popupCheatsAB'),

    ...uiConfig.buttons.primary,
    tracking: { feature: 'cheats', $subFeature: 'toggle-popup-cheats-ab' },
  });

  const popupCheatsContainer = new View({
    superview: container,

    x: (container.style.width / 3) * 2 - 18,
    y: 0,
    width: container.style.width / 3 - 3,
    height: container.style.height,

    clip: true,
  });

  new ButtonScaleViewWithText({
    superview: popupCheatsContainer,

    x: -21,
    y: 0,
    width: 116,
    height: 60,
    labelOffsetX: 5,
    labelOffsetY,
    fontSize: 20,
    font: bitmapFonts('Body'),

    localeText: () => 'Popups',
    onClick: () => togglePopup('popupTestPopups'),

    ...uiConfig.buttons.primary,
    tracking: { feature: 'cheats', $subFeature: 'toggle-popup-test-popups' },
  });
}
